import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { MdModeEdit, MdOutlineClose } from "react-icons/md";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useNotification } from "../../../../hooks/useNotification";
import useStyles from "../../../../themes/style.js";

const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

const maritalStatusList = [
  "Single",
  "Married",
  "Divorced",
  "Widowed",
  "Separated",
  "Prefer not to say",
];
const PersonalDetails = ({ userDetails, onUpdate }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [enableEdit, setEnableEdit] = useState(false);
  const handleNotificationCall = useNotification();
  const [employeeData, setEmployeeData] = useState(null);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),

    //employee schema
    dob: Yup.string(),
    gender: Yup.string().nullable().required("Gender is required"),
    bloodGroup: Yup.string().nullable(),
    maritalStatus: Yup.string().nullable(),
    spouseName: Yup.string().nullable(),
    personalEmail: Yup.string()
      .required("Personal Email is required")
      .email("Email must be a Valid Email Address"),

    fatherName: Yup.string().required("Father Name is required"),
    motherName: Yup.string().required("Mother Name is required"),
    emergencyMobile: Yup.string()
      .required("Emergency Contact Number is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    emergencyContactRelation: Yup.string(),
    currentAddress: Yup.string().required("Current Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    totalExperience: Yup.string().required(
      "Total Experience field is required",
    ),
  });

  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (userDetails) {
      const employee = userDetails?.employee
        ? userDetails?.employee
        : userDetails.recruiter;

      if (employee) {
        handleSetFieldValues(employee);
        setEmployeeData(employee);
      }
    }
  }, [userDetails]);

  const handleSetFieldValues = (employee) => {
    setValue("firstName", employee.firstName);
    setValue("lastName", employee.lastName);
    setValue("dob", employee.dob);
    setValue("gender", employee.gender);
    setValue("bloodGroup", employee.bloodGroup);
    setValue("personalEmail", employee.personalEmail);
    setValue("mobile", employee.mobile);
    setValue("roleName", userDetails?.roleName);
    setValue("fatherName", employee.fatherName);
    setValue("motherName", employee.motherName);

    setValue("maritalStatus", employee.maritalStatus);
    setValue("spouseName", employee.spouseName);
    setValue("currentAddress", employee.currentAddress);
    setValue("permanentAddress", employee.permanentAddress);
    setValue("emergencyContactRelation", employee.emergencyContactRelation);
    setValue("emergencyMobile", employee.emergencyMobile);
    setValue("totalExperience", employee.totalExperience);
  };

  const handleEditEmployee = async (values) => {
    setLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/editUserPersonalDetails`,
        {
          ...values,
          userId: userDetails.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        onUpdate();
        setEnableEdit(false);
      } else {
        handleNotificationCall("error", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  return (
    <Box>
      <div className="emp-profile-details-table-card">
        <h3 className="gradienttext">Personal Details</h3>
        {!enableEdit ? (
          <button
            className="emp-profile-edit-button"
            onClick={() => {
              handleSetFieldValues(employeeData);
              setEnableEdit(true);
            }}
          >
            <MdModeEdit color="#056dfa" className="svg-icon" />
            <span className="lable">Edit</span>
          </button>
        ) : (
          <button
            className="emp-profile-edit-button emp-profile-cancel-button"
            onClick={() => setEnableEdit(false)}
          >
            <MdOutlineClose color="#fa0505" className="svg-icon" />
            <span className="lable">Cancel</span>
          </button>
        )}

        {!enableEdit ? (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <table className="emp-profile-details-table">
                <tbody>
                  <tr>
                    <td>Name </td>
                    <td>
                      {userDetails.employee
                        ? userDetails.employee?.firstName
                        : userDetails.recruiter
                        ? userDetails.recruiter.firstName
                        : "-"}{" "}
                      {userDetails.employee
                        ? userDetails.employee?.lastName
                        : userDetails.recruiter
                        ? userDetails.recruiter.lastName
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>Age </td>
                    <td>{moment().diff(employeeData?.dob, "years")} years</td>
                  </tr>
                  <tr>
                    <td>Date of Birth </td>
                    <td>
                      {userDetails.employee ? (
                        moment(userDetails.employee?.dob).format("DD-MM-YYYY")
                      ) : userDetails.recruiter ? (
                        moment(userDetails.recruiter?.dob).format("DD-MM-YYYY")
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Gender </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.gender
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.gender
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Blood Group </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.bloodGroup
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.bloodGroup
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Personal Email </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.personalEmail
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.personalEmail
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Contact Number </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.mobile
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.mobile
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Father Name </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.fatherName
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.fatherName
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Mother Name </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.motherName
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.motherName
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <table className="emp-profile-details-table">
                <tbody>
                  <tr>
                    <td>Marital Status </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.maritalStatus
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.maritalStatus
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Spouse Name </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.spouseName
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.spouseName
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Current Address</td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.currentAddress
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.currentAddress
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Permanent Address </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.permanentAddress
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.permanentAddress
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Emergency Contact Number </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.emergencyMobile
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.emergencyMobile
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Emergency Contact Name & Relationship </td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.emergencyContactRelation
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.emergencyContactRelation
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Total Experience (in Years)</td>
                    <td>
                      {userDetails.employee ? (
                        userDetails.employee?.totalExperience
                      ) : userDetails.recruiter ? (
                        userDetails.recruiter.totalExperience
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}{" "}
                      Years
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        ) : (
          <form
            onSubmit={handleSubmit(handleEditEmployee)}
            style={{ padding: "10px" }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="firstName">
                  First Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter First Name"
                    name="firstName"
                    {...register("firstName")}
                    error={errors.firstName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.firstName?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="lastName">
                  Last Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    placeholder="Enter Last Name"
                    name="lastName"
                    {...register("lastName")}
                    error={errors.lastName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.lastName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="dob">
                  Date of Birth
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    size="small"
                    type="date"
                    placeholder="Select employee date of birth"
                    id="dob"
                    {...register("dob")}
                    error={errors.dob ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.dob?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="gender">
                  Gender
                </InputLabel>
                <FormControl className={classes.margin}>
                  <Controller
                    name="gender"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={errors.gender ? true : false}
                        classes={{
                          root: classes.customSelectField,
                          icon: classes.customSelectIcon,
                        }}
                        disableUnderline
                      >
                        <MenuItem value="">Select option</MenuItem>
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Transgender">Transgender</MenuItem>
                        <MenuItem value="Prefer not to say">
                          Prefer not to say
                        </MenuItem>
                      </Select>
                    )}
                  />
                  <Typography variant="inherit" color="error">
                    {errors.gender?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="bloodGroup">
                  Blood Group
                </InputLabel>
                <FormControl className={classes.margin}>
                  <Controller
                    name="bloodGroup"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={errors.bloodGroup ? true : false}
                        classes={{
                          root: classes.customTextField,
                          icon: classes.customSelectIcon,
                        }}
                        disableUnderline
                      >
                        <MenuItem value="">Select option</MenuItem>
                        {bloodGroups.map((group) => (
                          <MenuItem key={group} value={group}>
                            {group}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  <Typography variant="inherit" color="error">
                    {errors.bloodGroup?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="mobile">
                  Contact Number
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    type="number"
                    placeholder="Enter Mobile Number"
                    id="mobile"
                    name="mobile"
                    {...register("mobile")}
                    error={errors.mobile ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.mobile?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="personalEmail">
                  Personal Email
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    placeholder="Enter Persaonal Email"
                    name="personalEmail"
                    {...register("personalEmail")}
                    error={errors.personalEmail ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.personalEmail?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="fatherName">
                  Father Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Father Name"
                    name="fatherName"
                    {...register("fatherName")}
                    error={errors.fatherName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.fatherName?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="motherName">
                  Mother Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    placeholder="Enter Mother Name"
                    name="motherName"
                    {...register("motherName")}
                    error={errors.motherName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.motherName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="maritalStatus">
                  Marital Status
                </InputLabel>
                <FormControl className={classes.margin}>
                  <Controller
                    name="maritalStatus"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        error={errors.maritalStatus ? true : false}
                        classes={{
                          root: classes.customTextField,
                          icon: classes.customSelectIcon,
                        }}
                        disableUnderline
                      >
                        <MenuItem value="">Select option</MenuItem>
                        {maritalStatusList.map((group) => (
                          <MenuItem key={group} value={group}>
                            {group}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  <Typography variant="inherit" color="error">
                    {errors.maritalStatus?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="spouseName">
                  Spouse Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Spouse Name"
                    name="spouseName"
                    {...register("spouseName")}
                    error={errors.spouseName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.spouseName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="emergencyMobile">
                  Emergency Contact Number
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    type="number"
                    placeholder="Enter Emergency Mobile Number"
                    id="emergencyMobile"
                    name="emergencyMobile"
                    {...register("emergencyMobile")}
                    error={errors.emergencyMobile ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.emergencyMobile?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="emergencyContactRelation">
                  Emergency Contact Name & Relationship
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    placeholder="Enter Emergency Contact Name & Relationship"
                    name="emergencyContactRelation"
                    {...register("emergencyContactRelation")}
                    error={errors.emergencyContactRelation ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.emergencyContactRelation?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="currentAddress">
                  Current Address
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Current Address"
                    name="currentAddress"
                    {...register("currentAddress")}
                    error={errors.currentAddress ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.currentAddress?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="permanentAddress">
                  Permanent Address
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    size="small"
                    placeholder="Enter Permanent Address"
                    name="permanentAddress"
                    {...register("permanentAddress")}
                    error={errors.permanentAddress ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.permanentAddress?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <InputLabel shrink htmlFor="totalExperience">
                  Total Experience (in Years)
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    size="small"
                    classes={{ root: classes.customTextField }}
                    InputProps={{ disableUnderline: true }}
                    placeholder="Enter Employee Total Experience"
                    name="totalExperience"
                    {...register("totalExperience")}
                    error={errors.totalExperience ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.totalExperience?.message}
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{ flex: 1, margin: "0px 6px" }}
                  onClick={() => setEnableEdit(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ flex: 1, margin: "0px 6px" }}
                  type="submit"
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default PersonalDetails;
